import _ from "lodash";
import { useContext, useEffect } from "react";
import { UserContext } from "../contexts/UserContext";
import { createToast } from "../utils/toast";
import { _ROUTER_DOM_URL } from "../utils/_routes_constants";
import { getCookie } from "../utils/cookieHelper";

export const SecurityHandler = () => {
  const { getUser, token } = useContext(UserContext);
  const user = getUser();

  useEffect(() => {
    const route = window.location.pathname;
    // Si on est sur la page de changement de mot de passe on ne fait rien
    if (route.includes("set-password")) {
      return;
    }
    // Si les données ne sont ni dans le contexte ni dans le cookie on redirige vers la page de connexion
    if (_.isEmpty(user) && window.location.pathname !== "/") {
      createToast("error", "You are not logged in").then(() => {
        // J'utilise window.location.href pour forcer le rechargement de la page et la recompliation de React
        window.localStorage.setItem("redirect", window.location.pathname);
        window.location.href = _ROUTER_DOM_URL.HOME;
      });
    }

    // Si le token n'est pas dans le contexte ni dans les cookies on redirige vers la page de connexion
    if (!token && !getCookie("token") && window.location.pathname !== "/") {
      createToast("error", "You are not logged in").then(() => {
        window.localStorage.setItem("redirect", window.location.pathname);
        window.location.href = _ROUTER_DOM_URL.HOME;
      });
    }
  }, []);

  return <></>;
};
